<script setup>
import { computed } from 'vue'
import { useGlobalStore } from '@stores/global'
import Loading from '@components/global/Loading.vue'
import Hero from '@sections/index/Hero.vue'
import FeaturedEvents from '@sections/global/FeaturedEvents.vue'
import LatestNews from '@sections/index/LatestNews.vue'

const global = useGlobalStore()

const homepage = computed(() => global.pages.find((page) => page.slug === 'homepage'))

const blocks = {
	hero_homepage: Hero,
	featured_events: FeaturedEvents,
}
</script>

<template>
	<Loading v-if="!homepage" />
	<template v-else>
		<template v-for="(block, index) in homepage.content" :key="index">
			<component :is="blocks[block.type]" v-if="blocks[block.type]" :data="block.data" />
		</template>
		<LatestNews />
	</template>
</template>
